import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class TaxNumbersProxy extends BaseProxy implements ProxyMethods {
  public endpoint = ''

  constructor(companyId: string, parameters: object = {}) {
    super(parameters)
    this.endpoint = `companies/${companyId}/tax-numbers`
  }

  all() {
    return this.submit('get', `/${this.endpoint}`)
  }
}

export class SenderAddressTaxNumbersProxy extends BaseProxy implements ProxyMethods {
  public endpoint = ''

  constructor(companyId: string, senderAddressId: string, parameters: object = {}) {
    super(parameters)
    this.endpoint = `companies/${companyId}/sender-addresses/${senderAddressId}/tax-numbers`
  }

  all() {
    return this.submit('get', `/${this.endpoint}`)
  }

  create(data: { countryCode: string; taxNumber: string }) {
    return this.submit('post', `/${this.endpoint}`, data)
  }

  update(id: string, data: { countryCode: string; taxNumber: string }) {
    return this.submit('put', `/${this.endpoint}/${id}`, data)
  }

  destroy(id: string) {
    return this.submit('delete', `/${this.endpoint}/${id}`)
  }
}
